const filterRecord = value => value && typeof value === 'object' && !Array.isArray(value) ? value : {};

export const receiptListScope = (props, networkId) => JSON.stringify([
  networkId, props.view || 'simple', props.receiptGroup || null,
  props.receiptType || null, props.backlink || null, props.projectRetentionSearchQuery || null
]);

export const hasReceiptSearch = (query, filters = {}, fixedGroup = null, fixedType = null) =>
  !!(query || '').trim() || Object.entries(filterRecord(filters)).some(([key, filter]) => {
    if (['in_review', 'inReview'].includes(key)) return false;
    if (fixedGroup && ['receipt_group', 'receiptGroup'].includes(key)) return false;
    if (fixedType && ['receipt_type', 'receiptType'].includes(key)) return false;
    const value = filter?.value;
    return value !== null && value !== undefined && value !== '' && (!Array.isArray(value) || value.length > 0);
  });

export const normalReceiptFilters = (filters = {}) => {
  const {inReview, ...rest} = filterRecord(filters);
  return {...rest, in_review: {value: false, matchMode: 'equals'}};
};

export const receiptSort = (state = {}) => state?.sortField && [1, -1].includes(state.sortOrder)
  ? {sortField: state.sortField, sortOrder: state.sortOrder}
  : {sortField: 'issue_date', sortOrder: -1};

export const sortReceiptList = (current, event) => ({
  ...current,
  ...receiptSort(event),
  first: 0,
  page: 0,
  filters: normalReceiptFilters(current?.filters),
});
